import React, { useState } from 'react';
import ChatInterface from './components/ChatInterface';

function App() {
  // 全域聊天狀態管理
  const [chatState, setChatState] = useState(() => {
    // 從localStorage恢復聊天狀態
    const savedState = localStorage.getItem('chatState');
    if (savedState) {
      try {
        return JSON.parse(savedState);
      } catch (e) {
        console.error('恢復聊天狀態失敗:', e);
      }
    }
    return {
      messages: [{ 
        role: 'assistant', 
        content: '您好！我是智慧照顧產品推薦專家，請問您在尋找哪方面的協助或產品呢？' 
      }],
      conversationId: null
    };
  });

  // 更新聊天狀態並持久化
  const updateChatState = (newState) => {
    setChatState(newState);
    localStorage.setItem('chatState', JSON.stringify(newState));
    
    // 手動觸發自定義事件來通知其他組件
    window.dispatchEvent(new CustomEvent('chatStateChanged', { 
      detail: newState 
    }));
  };

  const appStyle = {
    minHeight: '100vh',
    backgroundColor: '#F1F5F9',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  };

  return (
    <div style={appStyle}>
      <ChatInterface 
        chatState={chatState}
        updateChatState={updateChatState}
      />
    </div>
  );
}

export default App; 